import axios from "axios";
const API_BASE_URL = "https://stats.goptgc.com";

const api = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true,
    headers: {
        Accept: "application/json"
    }
});

api.defaults.xsrfCookieName = "XSRF-TOKEN";
api.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
api.interceptors.request.use((config) => {
    return config;
});
export default api;